import { render } from "./MatchingSuggest.vue?vue&type=template&id=50e3795c&scoped=true"
import script from "./MatchingSuggest.vue?vue&type=script&lang=js"
export * from "./MatchingSuggest.vue?vue&type=script&lang=js"

import "@/assets/css/layout_suggest.css?vue&type=style&index=0&id=50e3795c&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e3795c"]])

export default __exports__